export enum PreRegistrationStatus {
  Reject = 'REJECT',
  Delete = 'DELETE',
  Confirm = 'CONFIRM',
  Transfer = 'TRANSFER',
  NotChecked = 'NOT_CHECKED',
  Expire = 'EXPIRE',
}
